import { sanitizeHtml } from "utils/sanitizeHtml";
import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: string;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} mb-20 lg:mb-36`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="flex-grow">
          <img className="w-full  rounded-xl" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2
            className="text-3xl !leading-tight font-bold text-text-color md:text-4xl xl:text-5xl"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(heading) }}
          />
          <span
            className="block xl:text-lg text-text-color"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(subHeading) }}
          />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
